import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { RevealLine, Rise, SectionLabel } from "./Motion";

const stats = [
  { k: "25+", v: "Years of promoter expertise" },
  { k: "400", v: "KV transmission capability (up to)" },
  { k: "100", v: "MW renewable projects (up to)" },
  { k: "PAN", v: "India project footprint" },
];

export default function Overview() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section
      id="about"
      ref={ref}
      className="relative overflow-hidden bg-white py-24 lg:py-36"
      data-testid="about-section"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <SectionLabel>01 — Who we are</SectionLabel>

        <div className="mt-10 grid grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-7">
            <h2 className="font-display text-4xl font-semibold leading-[1.05] tracking-tight text-vg-primary sm:text-5xl lg:text-6xl">
              <RevealLine>Turnkey EPC, engineered</RevealLine>
              <RevealLine delay={0.08}>for the energy transition.</RevealLine>
            </h2>
            <Rise delay={0.15} className="mt-8 max-w-2xl space-y-6 text-base leading-relaxed text-vg-muted lg:text-lg">
              <p>
                Venus Green Renewables &amp; Energy Pvt. Ltd. is an Engineering,
                Procurement and Construction company providing full turnkey
                solutions across power transmission and large-scale
                infrastructure projects in India.
              </p>
              <p>
                Anchored by the domain expertise and industry relationships of
                our promoters, we combine deep technical execution with strong
                partnerships across public sector undertakings, government
                agencies and leading private EPC firms — delivering projects
                that are reliable, on-schedule and built to last.
              </p>
            </Rise>
          </div>

          <div className="lg:col-span-5">
            <motion.div
              style={{ y: imgY }}
              className="relative aspect-[4/5] overflow-hidden rounded-sm"
            >
              <img
                src="https://images.unsplash.com/photo-1566543042578-5db95b961375?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHx0cmFuc21pc3Npb24lMjB0b3dlcnMlMjBza3l8ZW58MHx8fHwxNzg0MzUxMTIxfDA&ixlib=rb-4.1.0&q=85"
                alt="High-voltage transmission towers"
                className="h-[116%] w-full object-cover"
              />
            </motion.div>
          </div>
        </div>

        <div className="mt-20 grid grid-cols-2 gap-px overflow-hidden rounded-sm border border-vg-border bg-vg-border lg:grid-cols-4">
          {stats.map((s, i) => (
            <Rise
              key={s.v}
              delay={i * 0.08}
              className="bg-white p-8 lg:p-10"
            >
              <div className="font-display text-4xl font-semibold text-vg-primary lg:text-5xl">
                {s.k}
              </div>
              <div className="mt-3 text-sm text-vg-muted">{s.v}</div>
            </Rise>
          ))}
        </div>
      </div>
    </section>
  );
}
